import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCurrencyDollar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCurrencyDollar"><Path d="M12 23.5V0.5" stroke="currentColor"/><Path d="M5.25 17.3619C7.41667 22.1546 18.25 21.7915 18.25 16.7234C18.25 10.8198 5.79167 13.8591 5.79167 7.32001C5.79167 2.72209 14.1646 1.94992 17.47 5.36082" stroke="currentColor"/></CentralIconBase>;
});

export default IconCurrencyDollar;
